module.exports = __webpack_public_path__ + "static/media/milestonecheck2.4dfb7e05.svg";